const buttonTypes = {
  LINK: 'link',
  MODAL: 'modal',
  DISABLED: 'disabled',
  AUTHENTICATION: 'authentication',
  DEACTIVATED: 'deactivated',
  DROPDOWN: 'drop-down'
};

export default buttonTypes;



// WEBPACK FOOTER //
// ./src/app/components/Button/buttonTypes.js